import {
    CREATING_CLEVERSTORY_WORKSPACE_REQUEST,
    CREATING_CLEVERSTORY_WORKSPACE_SUCCEEDED,
    CREATING_CLEVERSTORY_WORKSPACE_FAILED,
    UPDATING_CLEVERSTORY_WORKSPACE_REQUEST,
    UPDATING_CLEVERSTORY_WORKSPACE_SUCCEEDED,
    UPDATING_CLEVERSTORY_WORKSPACE_FAILED,
    FETCHING_CLEVERSTORY_WORKSPACES,
    FETCHING_CLEVERSTORY_WORKSPACES_SUCCEEDED,
    FETCHING_CLEVERSTORY_WORKSPACES_FAILED,
    CREATING_CLEVERSTORY_DOMAIN_REQUEST,
    CREATING_CLEVERSTORY_DOMAIN_SUCCEEDED,
    CREATING_CLEVERSTORY_DOMAIN_FAILED,
    UPDATING_CLEVERSTORY_DOMAIN_REQUEST,
    UPDATING_CLEVERSTORY_DOMAIN_SUCCEEDED,
    UPDATING_CLEVERSTORY_DOMAIN_FAILED,
    UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_REQUEST,
    UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_SUCCEEDED,
    UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_FAILED,
    FETCHING_CLEVERSTORY_DOMAINS,
    FETCHING_CLEVERSTORY_DOMAINS_SUCCEEDED,
    FETCHING_CLEVERSTORY_DOMAINS_FAILED,
    DELETING_CLEVERSTORY_DOMAIN_REQUEST,
    DELETING_CLEVERSTORY_DOMAIN_SUCCEEDED,
    DELETING_CLEVERSTORY_DOMAIN_FAILED
} from "constants/actionTypes";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const CLEVERSTORY_WORKSPACE_BASE_URL = `${API_URL}/api/1.0/workspaces`;

/** create workspace */
export const createCleverstoryWorkspace = createAction(CREATING_CLEVERSTORY_WORKSPACE_REQUEST);
const creatingCleverstoryWorkspaceSucceeded = createAction(CREATING_CLEVERSTORY_WORKSPACE_SUCCEEDED);
const creatingCleverstoryWorkspaceFailed = createAction(CREATING_CLEVERSTORY_WORKSPACE_FAILED);

function* createCleverstoryWorkspaceSaga(action) {
  let url = buildUrl(CLEVERSTORY_WORKSPACE_BASE_URL);
  const createCleverstoryWorkspaceAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: action.payload
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createCleverstoryWorkspaceAPI);
    yield put(creatingCleverstoryWorkspaceSucceeded(response));
  } catch (error) {
    yield put(creatingCleverstoryWorkspaceFailed(error));
  }
}

/** fetch workspaces */
export const fetchCleverstoryWorkspaces = createAction(FETCHING_CLEVERSTORY_WORKSPACES);
const fetchingCleverstoryWorkspacesSucceeded = createAction(FETCHING_CLEVERSTORY_WORKSPACES_SUCCEEDED);
const fetchingCleverstoryWorkspacesFailed = createAction(FETCHING_CLEVERSTORY_WORKSPACES_FAILED);

function* fetchCleverstoryWorkspacesSaga(action) {
  let url = buildUrl(CLEVERSTORY_WORKSPACE_BASE_URL);
  const fetchCleverstoryWorkspacesAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: action.payload
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCleverstoryWorkspacesAPI);
    yield put(fetchingCleverstoryWorkspacesSucceeded(response));
  } catch (error) {
    yield put(fetchingCleverstoryWorkspacesFailed(error));
  }
}

/** update workspace */
export const updateCleverstoryWorkspace = createAction(UPDATING_CLEVERSTORY_WORKSPACE_REQUEST);
const updatingCleverstoryWorkspaceSucceeded = createAction(UPDATING_CLEVERSTORY_WORKSPACE_SUCCEEDED);
const updatingCleverstoryWorkspaceFailed = createAction(UPDATING_CLEVERSTORY_WORKSPACE_FAILED);

function* updateCleverstoryWorkspaceSaga(action) {
  let {id, data} = action.payload;
  let url = buildUrl(CLEVERSTORY_WORKSPACE_BASE_URL, {path: `${id}`});
  const fetchCleverstoryWorkspaceAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: data
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCleverstoryWorkspaceAPI);
    yield put(updatingCleverstoryWorkspaceSucceeded(response));
  } catch (error) {
    yield put(updatingCleverstoryWorkspaceFailed(error));
  }
}

/** fetch domains */
export const fetchCleverstoryDomains = createAction(FETCHING_CLEVERSTORY_DOMAINS);
const fetchingCleverstoryDomainsSucceeded = createAction(FETCHING_CLEVERSTORY_DOMAINS_SUCCEEDED);
const fetchingCleverstoryDomainsFailed = createAction(FETCHING_CLEVERSTORY_DOMAINS_FAILED);

function* fetchCleverstoryDomainsSaga(action) {
  let {workspace} = action.payload;  
  let url = buildUrl(CLEVERSTORY_WORKSPACE_BASE_URL,  {path: `${workspace}/domains`});
  const fetchCleverstoryDomainsAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: action.payload
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCleverstoryDomainsAPI);
    yield put(fetchingCleverstoryDomainsSucceeded(response));
  } catch (error) {
    yield put(fetchingCleverstoryDomainsFailed(error));
  }
}

/** create domain */
export const createCleverstoryDomain = createAction(CREATING_CLEVERSTORY_DOMAIN_REQUEST);
const creatingCleverstoryDomainSucceeded = createAction(CREATING_CLEVERSTORY_DOMAIN_SUCCEEDED);
const creatingCleverstoryDomainFailed = createAction(CREATING_CLEVERSTORY_DOMAIN_FAILED);

function* createCleverstoryDomainSaga(action) {
  let {id, data} = action.payload;  
  let url = buildUrl(CLEVERSTORY_WORKSPACE_BASE_URL, {path: `${id}/domains`});
  const createCleverstoryDomainAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: data
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createCleverstoryDomainAPI);
    yield put(creatingCleverstoryDomainSucceeded(response));
  } catch (error) {
    yield put(creatingCleverstoryDomainFailed(error));
  }
}

/** update domain */
export const updateCleverstoryDomain = createAction(UPDATING_CLEVERSTORY_DOMAIN_REQUEST);
const updatingCleverstoryDomainSucceeded = createAction(UPDATING_CLEVERSTORY_DOMAIN_SUCCEEDED);
const updatingCleverstoryDomainFailed = createAction(UPDATING_CLEVERSTORY_DOMAIN_FAILED);

function* updateCleverstoryDomainSaga(action) {
  let {workspaceId, domainId, data} = action.payload;  
  let url = buildUrl(CLEVERSTORY_WORKSPACE_BASE_URL, {path: `${workspaceId}/domains/${domainId}`});
  const updateCleverstoryDomainAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: data
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCleverstoryDomainAPI);
    yield put(updatingCleverstoryDomainSucceeded(response));
  } catch (error) {
    yield put(updatingCleverstoryDomainFailed(error));
  }
}

/** update domain as primary */
export const updateCleverstoryDomainAsPrimary = createAction(UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_REQUEST);
const updatingCleverstoryDomainAsPrimarySucceeded = createAction(UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_SUCCEEDED);
const updatingCleverstoryDomainAsPrimaryFailed = createAction(UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_FAILED);

function* updateCleverstoryDomainAsPrimarySaga(action) {
  let {workspaceId, domainId, data} = action.payload;  
  let url = buildUrl(CLEVERSTORY_WORKSPACE_BASE_URL, {path: `${workspaceId}/domains/${domainId}`});
  const updateCleverstoryDomainAsPrimaryAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: data
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateCleverstoryDomainAsPrimaryAPI);
    yield put(updatingCleverstoryDomainAsPrimarySucceeded(response));
  } catch (error) {
    yield put(updatingCleverstoryDomainAsPrimaryFailed(error));
  }
}

export const deleteCleverstoryDomain = createAction(DELETING_CLEVERSTORY_DOMAIN_REQUEST);
const deletingIADBMetadataSucceeded = createAction(DELETING_CLEVERSTORY_DOMAIN_SUCCEEDED);
const deletingIADBMetadataFailed = createAction(DELETING_CLEVERSTORY_DOMAIN_FAILED);

function* deleteCleverstoryDomainSaga(action) {
  let { workspaceId, domainId } = action.payload;
  let url = buildUrl(CLEVERSTORY_WORKSPACE_BASE_URL, { path: `${workspaceId}/domains/${domainId}` });
  const deleteCleverstoryDomainAPI = () => {
    return axios({
      method: "DELETE",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteCleverstoryDomainAPI);
    yield put(deletingIADBMetadataSucceeded(response));
  } catch (error) {
    yield put(deletingIADBMetadataFailed(error));
  }
}

export default function* cleverstoryWorkspaceSaga() {
  yield takeLatest(FETCHING_CLEVERSTORY_WORKSPACES, fetchCleverstoryWorkspacesSaga);
  yield takeLatest(CREATING_CLEVERSTORY_WORKSPACE_REQUEST, createCleverstoryWorkspaceSaga);
  yield takeLatest(UPDATING_CLEVERSTORY_WORKSPACE_REQUEST, updateCleverstoryWorkspaceSaga);
  yield takeLatest(FETCHING_CLEVERSTORY_DOMAINS, fetchCleverstoryDomainsSaga);
  yield takeLatest(CREATING_CLEVERSTORY_DOMAIN_REQUEST, createCleverstoryDomainSaga);
  yield takeLatest(UPDATING_CLEVERSTORY_DOMAIN_REQUEST, updateCleverstoryDomainSaga);
  yield takeLatest(UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_REQUEST, updateCleverstoryDomainAsPrimarySaga);
  yield takeLatest(DELETING_CLEVERSTORY_DOMAIN_REQUEST, deleteCleverstoryDomainSaga);
}
